import { RedirectComponent } from './components/redirect/redirect.component';
import { ReceiptComponent } from './components/receipt/receipt.component';
import { CheckProviderComponent } from './components/check-provider/check-provider.component';
import { ChooseAbonentComponent } from './components/choose-abonent/choose-abonent.component';
import { NotFoundComponent } from './components/not-found/not-found.component';
import { ProviderComponent } from './components/provider/provider/provider.component';
import { ProvidersHomeComponent } from './components/provider/providers-home/providers-home.component';
import { NgModule } from '@angular/core';
import { Routes, RouterModule, UrlMatcher } from '@angular/router';
import { BasketComponent } from './components/basket/basket.component';
import { HistoryComponent } from './components/history/history.component';
import { Language } from './util/lang';


const lang = Language.getCurrentLang();

const routes: Routes = [
  { path: '', redirectTo: `${lang}/providers`, pathMatch: 'full' },
  { path: `providers`, redirectTo: `hy/providers` },
  { path: `:lang/providers`, component: ProvidersHomeComponent },
  { path: `providers/:id`, redirectTo: `hy/providers/:id` },
  { path: `:lang/providers/:id`, component: ProvidersHomeComponent },
  { path: `provider/:id`, redirectTo: `hy/provider/:id` },
  { path: `:lang/provider/:id`, component: ProviderComponent },
  { path: `chooseabonent/:id`, redirectTo: `hy/chooseabonent/:id` },
  { path: `:lang/chooseabonent/:id`, component: ChooseAbonentComponent },
  { path: `prepayment/:id`,redirectTo: `hy/prepayment/:id` },
  { path: `:lang/prepayment/:id`, component: CheckProviderComponent },
  { path: `pay/:id`, redirectTo: `hy/pay/:id`},
  { path: `:lang/pay/:id`, component: CheckProviderComponent },
  { path: `redirect/:id`, redirectTo:`hy/redirect/:id` },
  { path: `:lang/redirect/:id`, component: RedirectComponent },
  { path: `paymenthistory`, redirectTo:`hy/paymenthistory`},
  { path: `:lang/paymenthistory`, component: HistoryComponent },
  { path: `receipt/:id`, redirectTo:`hy/receipt/:id`},
  { path: `:lang/receipt/:id`, component: ReceiptComponent },
  { path: `:lang/notfound`, component: NotFoundComponent },
  { path: '**', redirectTo: `hy/notfound` }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
